import { Box, Tab, Tabs, useTheme } from "@mui/material";
import { useState } from "react";
import { stylesPage } from "./styles";
import Routers from "./routers";
import Interfaces from "./interfaces";
import Blocos from "./blocos";
import Asns from "./asns";
import Cdns from "./cdns";
import Ports from "./ports";
import {
  CloudSync,
  ElectricalServices,
  Hub,
  Router,
  SettingsEthernet,
  ViewModule,
} from "@mui/icons-material";

export default function RelatoriosFlow() {
  const [value, setValue] = useState<number>(0);

  const theme = useTheme();
  const styles = stylesPage(theme);

  return (
    <>
      <Box sx={styles.container}>
        <Tabs
          onChange={(_event, newValue) => {
            setValue(newValue);
          }}
          value={value}
          sx={{
            "& button.Mui-selected": {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.primary.main,
            },
          }}
        >
          <Tab
            label={
              <Box sx={styles.boxTab}>
                <Router />
                Router
              </Box>
            }
            value={0}
          />
          <Tab
            label={
              <Box sx={styles.boxTab}>
                <SettingsEthernet />
                Interfaces
              </Box>
            }
            value={1}
          />
          <Tab
            label={
              <Box sx={styles.boxTab}>
                <ViewModule />
                Blocos
              </Box>
            }
            value={2}
          />
          <Tab
            label={
              <Box sx={styles.boxTab}>
                <Hub fontSize="small" />
                ASNs
              </Box>
            }
            value={3}
          />
          <Tab
            label={
              <Box sx={styles.boxTab}>
                <CloudSync />
                CDNs
              </Box>
            }
            value={4}
          />
          <Tab
            label={
              <Box sx={styles.boxTab}>
                <ElectricalServices />
                Ports
              </Box>
            }
            value={5}
          />
        </Tabs>

        {value === 0 && <Routers key={1} />}
        {value === 1 && <Interfaces key={2} />}
        {value === 2 && <Blocos key={3} />}
        {value === 3 && <Asns key={4} />}
        {value === 4 && <Cdns key={5} />}
        {value === 5 && <Ports key={6} />}
      </Box>
    </>
  );
}
